import axiosInstance from "../../api/axiosInstance";

export const fetchAdminsAPI = async () => {
  const adminsList = await axiosInstance.get(
    "admins/get-all-admins-with-roles"
  );
  return adminsList.data;
};

export const deleteAdminAPI = async (id) => {
  const deletedAdmin = await axiosInstance.delete(`admins/delete-admin/${id}`);

  return deletedAdmin.data;
};

export const createAdminAPI = async (adminData) => {
  const createdAdmin = await axiosInstance.post(
    "admins/create-admin",
    adminData
  );

  return createdAdmin.data;
};

export const updateAdminAPI = async (adminId, adminData) => {
  const updatedAdmin = await axiosInstance.put(
    `admins/update-admin/${adminId}`,
    adminData
  );

  return updatedAdmin.data;
};

export const fetchOneAdmniAPI = async (adminId) => {
  const admin = await axiosInstance.get(`admins//find-admin/${adminId}`);

  return admin.data;
};
